import React, { useMemo } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const BreadcrumbHistory = ({ url }) => {
  const {t} = useTranslation();

  const product = useSelector((state) => state.products.product);

  const renderBreadCrumbs = useMemo(() => {
    let route = url.split('/')
      .slice(1)
      .map(route => {
        const words = route.split('-');
        // Only capitalize first letter of first word
        return words[0][0].toUpperCase() + words[0].slice(1) + 
          (words.length > 1 ? ' ' + words.slice(1).join(' ') : '');
      });

    const length = route.length;
    const indexRouteProduct = route.indexOf("Products");

    // Handle detail/edit paths and format IDs
    const processedRoute = [];
    for (let i = 0; i < route.length; i++) {
      if (i < route.length - 1 && (route[i + 1] === 'Detail' || route[i + 1] === 'Edit')) {
        // Check if current item is a number (ID)
        if (!isNaN(route[i])) {
          // Get the parent route name and convert to singular form
          const parentRoute = i > 0 ? route[i - 1].replace(/s$/, '') : '';
          // Translate the parent route before adding the ID
          const translatedParent = t(parentRoute);
          processedRoute.push(`${translatedParent} #${route[i]}`);
        } else {
          processedRoute.push(route[i]);
        }
        i++; // Skip the next item (Detail/Edit)
      } else {
        processedRoute.push(route[i]);
      }
    }

    return processedRoute.map((item, index) => {
      const middlewareUrl = "/" + url.split('/').slice(1, index + 2).join('/');
      const isLastItem = length === index + 1;
      const isProductItem = indexRouteProduct !== -1 && product && index === indexRouteProduct + 1;
      const isIdItem = !isNaN(item.split('#')[1]?.trim());

      return (
        <BreadcrumbItem key={uuidv4()}>
          {isLastItem || isIdItem ? (
            t(item)
          ) : isProductItem ? (
            <Link to={middlewareUrl}>
              {product.countNr}
            </Link>
          ) : (
            <Link to={middlewareUrl}>
              {t(item)}
            </Link>
          )}
        </BreadcrumbItem>
      );
    });
  }, [url, product, t]);

  return (
    <div>
      <Row className="mb-3">
        <Col md="6"><Breadcrumb tag="nav" listTag="div">
          {renderBreadCrumbs}
        </Breadcrumb>
        </Col>
      </Row>
    </div>
  );
};

export default BreadcrumbHistory;
